import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialProjectItemTemplateState: Dtos.ProjectItemTemplate & IRegistrationFormState = {
    id: null,
    trialId: null,
    trial: null,
    name: null,
    description: null,
    rank: null,
    projectItemTemplateCategoryId: null,
    projectItemTemplateCategory: null,
    auditOnSave: null,
    allowVersions: null,
    collectionId: null,
    collection: null,
    isDefault: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false
}

export interface IProjectItemTemplateReduxFormState {
    id: IFieldState<number>,
    trialId: IFieldState<number>,
    name: IFieldState<string>,
    description: IFieldState<string>,
    rank: IFieldState<number>,
    projectItemTemplateCategoryId: IFieldState<number>,
    auditOnSave: IFieldState<boolean>,
    allowVersions: IFieldState<boolean>,
    isDefault: IFieldState<boolean>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    message: IFieldState<string>,
    openedModals: IFieldState<string[]>,
    collectionId: IFieldState<number>,
    collection: IFieldState<Dtos.Collection>,
}
